import { lazy } from "react";

export const ManageUsersAsync = lazy(() => import("./ManageUsers"));
